<h1 mat-dialog-title>{{confirmationTitle | translate}}</h1>
<div mat-dialog-content>
  <p>{{confirmationMessage | translate}}</p>
</div>
<div fxLayoutAlign="start" fxLayoutGap="20px">
  <button mat-raised-button color="primary" [mat-dialog-close]="true">{{'YES' | translate}}</button>
  <button mat-button [mat-dialog-close]="false">{{'NO' | translate}}</button>
</div>
